<template>
  <div class="container-fluid product-wrapper">
    <div class="product-grid">
      <div class="p-4 bg-white mt-3 shadow-sm rounded">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="m-0">Roles & Permissions</h3>
          <div class="table-tools d-flex">
            <button class="btn btn-sm btn-outline-secondary me-2" @click="fetchData">
              <i class="fa fa-refresh me-1"></i> Refresh
            </button>
          </div>
        </div>
        
        <BaseTable
          storage-key="roles"
          :columns="tableCols"
          :data="tableData"
          :loading="loading"
          :total-items="total"
          v-model:current-page="allParams.page"
          v-model:page-size="allParams.limit"
        >
          <template #cell(permissions)="{ item }">
            <div class="d-flex flex-wrap gap-1">
                <span v-for="p in item.permissions?.slice(0, 5)" :key="p.id" class="badge bg-light text-dark border">
                    {{ p.display_name || p.name }}
                </span>
                <span v-if="item.permissions?.length > 5" class="badge bg-light text-muted border">
                    +{{ item.permissions.length - 5 }} more
                </span>
                <span v-if="!item.permissions?.length" class="text-muted small">No permissions</span>
            </div>
          </template>

          <template #actions="{ item }">
            <button class="btn btn-sm btn-primary" @click="openPermissions(item)">
              <i class="fa fa-lock me-1"></i> Permissions
            </button>
          </template>
        </BaseTable>
      </div>
    </div>

    <RolePermissionsForm
      :isOpen="isShowPermissionsForm"
      :roleData="selectedRole"
      @close="isShowPermissionsForm = false"
      @save="fetchData"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import BaseTable from "@/components/common/BaseTable.vue";
import { useRole } from "@/composables/useRole";
import RolePermissionsForm from './RolePermissionsForm.vue';
import { createToaster } from "@meforma/vue-toaster";

const toaster = createToaster({ position: "top-right", duration: 2000 });
const { getRolesApi } = useRole();

const loading = ref(false);
const tableData = ref([]);
const total = ref(0);
const isShowPermissionsForm = ref(false);
const selectedRole = ref(null);

const allParams = reactive({
  page: 1,
  limit: 10,
  include: 'permissions'
});

const tableCols = [
  { key: 'id', label: 'ID', width: '70px' },
  { key: 'name', label: 'System Name' },
  { key: 'display_name', label: 'Display Name' },
  { key: 'permissions', label: 'Permissions', width: '400px' },
];

const fetchData = async () => {
    loading.value = true;
    try {
        const res = await getRolesApi({ ...allParams });
        if (res.success && res.data) {
            tableData.value = res.data.data || [];
            total.value = res.data.meta?.pagination?.total || 0;
        } else {
            toaster.error(res.error || "Không thể tải dữ liệu");
        }
    } catch (err) {
        toaster.error("Có lỗi xảy ra");
    } finally {
        loading.value = false;
    }
};

const openPermissions = (item) => {
  selectedRole.value = { ...item };
  isShowPermissionsForm.value = true;
};

watch(() => [allParams.page, allParams.limit], fetchData);
onMounted(fetchData);
</script>

<style scoped>
.product-wrapper {
  padding-bottom: 50px;
}
</style>
